package dk.smark.chat.network

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

class UserApiService(
    private val baseUrl: String = "https://dbapi.smark.dk",
    private val client: HttpClient = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            })
        }
        install(HttpTimeout) {
            requestTimeoutMillis = 10_000
            connectTimeoutMillis = 10_000
        }
    }
) {

    // ── Health ─────────────────────────────────────────────────────────────

    /** GET / */
    suspend fun root(): String =
        client.get("$baseUrl/").body()

    /** GET /health */
    suspend fun healthCheck(): String =
        client.get("$baseUrl/health").body()

    // ── Users ──────────────────────────────────────────────────────────────

    /** GET /users */
    suspend fun listUsers(): List<User> =
        client.get("$baseUrl/users").body()

    /** GET /users/{id} */
    suspend fun getUserById(id: Int): User =
        client.get("$baseUrl/users/$id").body()

    /** GET /users/email/{email} */
    suspend fun getUserByEmail(email: String): User =
        client.get("$baseUrl/users/email/$email").body()

    /** POST /users */
    suspend fun createUser(request: CreateUserRequest): User =
        client.post("$baseUrl/users") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** POST /users/login */
    suspend fun login(request: LoginRequest): LoginResponse =
        client.post("$baseUrl/users/login") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** PUT /users/{id} — full replace */
    suspend fun replaceUser(id: Int, request: UpdateUserRequest): User =
        client.put("$baseUrl/users/$id") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** PATCH /users/{id} — partial update */
    suspend fun updateUser(id: Int, request: UpdateUserRequest): User =
        client.patch("$baseUrl/users/$id") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** PATCH /users/{id}/password */
    suspend fun changePassword(id: Int, request: ChangePasswordRequest): Unit =
        client.patch("$baseUrl/users/$id/password") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** DELETE /users/{id} */
    suspend fun deleteUser(id: Int): Unit =
        client.delete("$baseUrl/users/$id").body()

    /** POST /users/forgot-password */
    suspend fun forgotPassword(request: ForgotPasswordRequest): Unit =
        client.post("$baseUrl/users/forgot-password") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()
}